module.exports = "/assets/data/abb63f3128c229fb45d88b6783832d6c-LS8.data.json";